import type { IconNode } from '../types';

/**
 * @name case-camel
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI3IiBjeT0iMTMiIHI9IjMiIC8+CiAgPHBhdGggZD0iTTEwIDEwdjYiIC8+CiAgPHBhdGggZD0iTTE0IDEyaDQuNWEyIDIgMCAwIDEgMCA0SDE0VjhoNGEyIDIgMCAwIDEgMCA0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/case-camel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const caseCamel: IconNode = [
  ['circle', { cx: '7', cy: '13', r: '3', key: '1uvc11' }],
  ['path', { d: 'M10 10v6', key: '1xpje5' }],
  ['path', { d: 'M14 12h4.5a2 2 0 0 1 0 4H14V8h4a2 2 0 0 1 0 4', key: '1mk5vw' }],
];

export default caseCamel;
